import Script from 'next/script'
import { FC, useEffect, useRef, useState } from 'react'

interface Props {
  url?: string
}

const TikTok: FC<Props> = ({ url }) => {
  const [scriptLoaded, setScriptLoaded] = useState(false)
  const blockquoteRef = useRef<HTMLQuoteElement>(null)

  useEffect(() => {
    // Only process if script is loaded and we have a URL
    if (scriptLoaded && url && (window as any).tiktokEmbed?.load) {
      ;(window as any).tiktokEmbed.load()
    }
  }, [url, scriptLoaded])

  if (!url) return null

  const getVideoId = (url: string): string => {
    const match = url.match(/\/video\/(\d+)/)
    return match ? match[1] : ''
  }

  const videoId = getVideoId(url)

  if (!videoId) return null

  return (
    <>
      <Script
        id="tiktok-embed-script"
        src="https://www.tiktok.com/embed.js"
        strategy="lazyOnload"
        onLoad={() => setScriptLoaded(true)}
      />

      <blockquote
        ref={blockquoteRef}
        className="tiktok-embed"
        cite={url}
        data-video-id={videoId}
        style={{ minWidth: '100%' }}
      >
        <section>
          <a target="_blank" rel="noreferrer" href={url} />
        </section>
      </blockquote>
    </>
  )
}

export default TikTok
